import { render, staticRenderFns } from "./offerStatistics.vue?vue&type=template&id=7c9faec4&scoped=true"
import script from "./offerStatistics.vue?vue&type=script&lang=js"
export * from "./offerStatistics.vue?vue&type=script&lang=js"
import style0 from "./offerStatistics.vue?vue&type=style&index=0&id=7c9faec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9faec4",
  null
  
)

export default component.exports